import { NumberFormatter, Text } from '@mantine/core';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { isNullish } from 'remeda';
import { getCurrencySymbolFromCurrencyCode } from 'shared/utils/currency';

type NumberFormatterTableProps = { value: number | null; color?: string };

export const NumberFormatterTable = ({ value, color = 'gray.10' }: NumberFormatterTableProps) => {
  const company = useCompanyConfiguration();

  if (isNullish(value)) return null;

  return (
    <Text size="sm" c={color}>
      <NumberFormatter
        thousandSeparator=" "
        value={value}
        decimalScale={2}
        suffix={` ${getCurrencySymbolFromCurrencyCode(company.currency)}`}
      />
    </Text>
  );
};
